import { gql } from '@apollo/client';


export const CREATE_PROFILE_POINTS_ORDERS = gql`
mutation ($profile_uuid:ID!, $item:ID! $text_adicional:String){
     createProfilePointsOrders(profile_uuid:$profile_uuid, item:$item, text_adicional:$text_adicional){
         id,
         tournament_id,
   
         acreditaciones_profile_uuid,
         acreditaciones_profiles_points_products_id,
   
         status,
         amount,

         completed_at,
         created_at
     }
}   
`;
